"use client"

import { useState, useEffect, useRef } from "react"
import { Typography } from "@mui/material"

const Counter = ({ end, duration = 2000, suffix = "", variant = "h3", color, ...props }) => {
  const [count, setCount] = useState(0)
  const countRef = useRef(null)
  const [hasAnimated, setHasAnimated] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true)

          const startTime = Date.now()
          const endTime = startTime + duration

          const updateCount = () => {
            const now = Date.now()
            const progress = Math.min(1, (now - startTime) / duration)

            // Use easeOutQuad for smoother animation
            const easeProgress = 1 - (1 - progress) * (1 - progress)
            const currentCount = Math.floor(easeProgress * end)

            setCount(currentCount)

            if (now < endTime) {
              requestAnimationFrame(updateCount)
            } else {
              setCount(end)
            }
          }

          requestAnimationFrame(updateCount)
        }
      },
      { threshold: 0.1 },
    )

    if (countRef.current) {
      observer.observe(countRef.current)
    }

    const currentRef = countRef.current
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [end, duration, hasAnimated])

  return (
    <Typography ref={countRef} variant={variant} color={color} {...props}>
      {count}
      {suffix}
    </Typography>
  )
}

export default Counter

